export default __webpack_public_path__ + "static/media/map.5b8f1e33.svg";